"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@material-ui/icons/Error"));
const utils_1 = require("utils");
/*
  This component is displayed when an error occurs that breaks react rendering and would otherwise show a stacktrace to the user.
  If a user lands on this screen, there's a bug in the FE code that needs to be fixed.
*/
function FallbackErrorScreen({ error }) {
    const unknownErrorMessage = 'An unknown error occurred.';
    let errorMessage = '';
    try {
        if (!error)
            errorMessage = unknownErrorMessage;
        else if (typeof error === 'string')
            errorMessage = error;
        else if (error instanceof Error)
            errorMessage = error.message;
        else if (typeof error === 'object')
            errorMessage = JSON.stringify(error);
        (0, utils_1.reportError)('BoundaryError', {
            componentName: 'FallbackErrorScreen',
            errType: 'error',
            errURL: window.location.pathname,
            errMsg: errorMessage,
        });
    }
    catch {
        errorMessage = '';
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "page-container centered-container", children: (0, jsx_runtime_1.jsxs)("div", { className: "error-page-container", children: [(0, jsx_runtime_1.jsx)(Error_1.default, { style: { fontSize: 100 }, color: "disabled" }), (0, jsx_runtime_1.jsx)("h4", { className: "error-page-title", children: "An error occurred" }), (0, jsx_runtime_1.jsx)("p", { className: "error-page-paragraph", children: errorMessage ?? unknownErrorMessage })] }) }));
}
exports.default = FallbackErrorScreen;
